import { render, staticRenderFns } from "./orcidInfo.vue?vue&type=template&id=6636dfab"
import script from "./orcidInfo.vue?vue&type=script&lang=js"
export * from "./orcidInfo.vue?vue&type=script&lang=js"
import style0 from "./orcidInfo.vue?vue&type=style&index=0&id=6636dfab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports